import * as Yup from "yup";
import { createMapper } from "../../../../../utils/utils";
import {
  ChatFilterState,
  EmailFilterState,
  FaxFilterState,
  SmsTextFilterState,
} from "../components/FilterComponents";

// Contact type options
export const CONTACT_TYPE_OPTIONS = [
  { value: "LAB", label: "Lab" },
  { value: "CLINIC", label: "Clinic" },
  { value: "VENDOR", label: "Vendor" },
  { value: "PHARMACY", label: "Pharmacy" },
  { value: "PROVIDER", label: "Provider" },
  { value: "PATIENT", label: "Patient" },
  { value: "OTHER", label: "Other" },
  { value: "INSURANCE_PAYER", label: "Insurance Payer" },
  { value: "STAFF", label: "Staff" },
];

export const CONTACT_TYPE_OPTIONS_MAPPER = createMapper(CONTACT_TYPE_OPTIONS);

// Initial values for the form
export const CONTACT_INITIAL_VALUES = {
  contactType: undefined,
  firstName: undefined,
  lastName: undefined,
  fullName: undefined,
  contactNumber: undefined,
  faxNumber: undefined,
  email: undefined,
  address: undefined,
  description: undefined,
};

// Validation helpers (regex-free)
const isAlphabeticName = (value?: string) =>
  !!value &&
  [...value].every((char) => {
    const lower = char.toLowerCase();
    return (lower >= "a" && lower <= "z") || char === " " || char === "'" || char === "-";
  });

const isDigitsOnly = (value?: string | null) =>
  !!value && [...value].every((char) => char >= "0" && char <= "9");

// Validation schema
export const CONTACT_VALIDATION_SCHEMA = Yup.object({
  contactType: Yup.object().required().label("Contact Type"),
  firstName: Yup.string()
    .trim()
    .required("First Name is required")
    .test(
      "alphabeticOnly",
      "First Name must contain only alphabetic characters",
      isAlphabeticName
    ),
  lastName: Yup.string()
    .trim()
    .required("Last Name is required")
    .test(
      "alphabeticOnly",
      "Last Name must contain only alphabetic characters",
      isAlphabeticName
    ),
  contactNumber: Yup.string()
    .required("Contact Number is required")
    .length(10, "Contact Number must be a valid 10-digit number")
    .test(
      "digitsOnly",
      "Contact Number must be a valid 10-digit number",
      isDigitsOnly
    ),
  faxNumber: Yup.string()
    .nullable()
    .test("tenDigits", "Fax Number must be 10 digits", (value) =>
      value ? value.length === 10 && isDigitsOnly(value) : true
    ),
  email: Yup.string()
    .nullable()
    .email("Please enter a valid email address"),
  // address: Yup.object({
  //   line1: Yup.string().required("Address Line 1 is required"),
  //   line2: Yup.string().optional(),
  //   city: Yup.string().required("City is required"),
  //   state: Yup.string().required("State is required"),
  //   country: Yup.string().required("Country is required"),
  //   zipcode: Yup.string().required("ZIP Code is required"),
  // }).optional(),
  // description: Yup.string().optional(),
});

export interface ContactDictionaryFilterState {
  contactType: string;
  searchQuery: string;
  archive: boolean;
}

export const CONTACT_DICTIONARY_FILTER_INITIAL_VALUES: {
  sms: SmsTextFilterState;
  chat: ChatFilterState;
  email: EmailFilterState;
  fax: FaxFilterState;
  contact: ContactDictionaryFilter;
} = {
  sms: {
    messageType: "",
    searchQuery: "",
  },
  chat: {
    chatStatus: "",
    searchQuery: "",
  },
  email: {
    emailType: "",
    searchQuery: "",
  },
  fax: {
    faxStatus: "",
    searchQuery: "",
  },
  contact: {
    contactType: { value: "", label: "" } as any,
    searchQuery: "",
    archive: false,
  },
};

export interface ContactDictionaryFilter {
  contactType: { value: string; label: string };
  searchQuery: string;
  archive: boolean;
}
